import * as classNames from 'classnames';
import * as React from 'react';
import * as style from './ProgressBar.styl';

export interface IProgressBarProps<T> {
  pages: IProgressBarPage<T>[];
  currentPageId?: T;
}

export interface IProgressBarPage<T> {
  id: T;
}

function renderProgressBarCell<T>(key: number, isCompleted: boolean, isFirstCell: boolean, isLastCell: boolean) {
  const cardMappingClasses = classNames(
    'progress-bar-cell',
    { 'is-completed': isCompleted },
    { 'progress-bar-border-cell': isFirstCell || isLastCell },
    { 'last-progress-bar-cell': isLastCell }
  );

  return <div key={key} className={cardMappingClasses} />;
}

export function ProgressBar<T>(props: IProgressBarProps<T>) {
  const { pages, currentPageId } = props;

  const indexOfCurrentPage = pages.findIndex((page) => page.id === currentPageId);

  const pageCells = [];
  for (let x = 0; x < pages.length; x++) {
    const isCompleted = indexOfCurrentPage >= x;
    const isFirstCell = x === 0;
    const isLastCell = x === pages.length - 1;

    const cell = renderProgressBarCell(x, isCompleted, isFirstCell, isLastCell);
    pageCells.push(cell);
  }

  return (
    <div className={style.global}>
      <div className="meter">{pageCells}</div>
    </div>
  );
}
